import { useMemo, useState } from 'react';

export const useSpeechRecognition = () => {
    const [result, setResult] = useState('');
    const [isRunning, setIsRunning] = useState(false);
    const recognition = useMemo(() => {
        try {
            return new (
                window.SpeechRecognition
                || window.webkitSpeechRecognition
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                || window.SpeechRecognitionEvent
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                || window.msSpeechRecognition
            )();
        } catch {
            return undefined;
        }

    }, []);

    if (!recognition) {
        return { isAvailable: false };
    }

    recognition.lang = 'en-GB';

    recognition.onstart = () => {
        setIsRunning(true);
    };

    recognition.onresult = (event) => {
        if (event.results[0][0].transcript) {
            setResult(event.results[0][0].transcript);
        }
    };

    recognition.onend = () => {
        setIsRunning(false);
    };

    const handleStartStop = () => {
        if (isRunning) {
            recognition.stop();
        } else {
            recognition.start();
        }
    };

    return { isAvailable: true, result, isRunning, handleStartStop };
};
